module.exports = __webpack_public_path__ + "media/images/iconPaginatePrev__errorRed-f06e71642315cfe0caa80a761ea6d612.png";